
export default function PasswordModal({
  open,
  password,
  setPassword,
  onSubmit,
  error,
  loading,
  setPasswordError,
}) {
  if (!open) return null;

  return (
    <div className="pm-overlay">
      <div className={`pm-card ${error ? "pm-error-shake" : ""}`}>
        <h3>Password Required</h3>

        <input
          type="password"
          value={password || ""}
          onChange={(e) => {
            setPassword(e.target.value);
            setPasswordError("");
            }}
          placeholder="Enter password"
          autoFocus
          onKeyDown={(e) => e.key === "Enter" && onSubmit()}
        />

        {error && <div className="pm-error">{error}</div>}

        <button disabled={loading} onClick={onSubmit}>
            {loading ? <span className="loader"></span> : "OK"}
        </button>
      </div>
    </div>
  );
}